const CalendarTypes = {
    GET_CALENDAR_START:'GET_CALENDAR_START',
    GET_CALENDAR_SUCCESS:'GET_CALENDAR_SUCCESS',
    GET_CALENDAR_FAILED:'GET_CALENDAR_FAILED',

}

export default CalendarTypes